function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEmptyClock = function SvgEmptyClock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    fill: "none",
    viewBox: "0 0 42 42",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 40,
    height: 40,
    rx: 20,
    stroke: props.fill,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "bevel",
    strokeDasharray: "8 8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 12v11m7-4l-7 4",
    stroke: props.fill,
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }));
};
export default SvgEmptyClock;